import * as ACTIONS from '@/store/constants/actions.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { ZERO_UUID } from 'commons/constants/parse.js';

export const getCookie = (name) => {
    // Add additional semicolon to ensure cookie name isn't just being used as the value in another cookie
    const value = `; ${document.cookie};`;
    const ADDITIONAL_CHARACTERS = 3; // To compensate for `; =`
    let firstIndex = value.indexOf(`; ${ name }=`);

    if (firstIndex === -1) {
        return undefined;
    }

    firstIndex += name.length + ADDITIONAL_CHARACTERS;
    const secondIndex = value.indexOf(';', firstIndex);

    // Return the value of the desired cookie
    return value.substring(firstIndex, secondIndex);
};

export const actions = {
    [ACTIONS.FETCH_ACTIVE_SITE]({ commit }) {
        const cookie = getCookie('scope');
        const activeSite = cookie ? cookie : ZERO_UUID;
        commit(MUTATIONS.SET_ACTIVE_SITE, activeSite);
        return Promise.resolve();
    },
};
